import {
  BookOpenIcon,
  CalculatorIcon,
  BeakerIcon,
  TvIcon,
} from "@heroicons/react/24/outline";
import fallBackImage from '../Assests/images/placeholderimage.jpg'

const UsageCard = ({
  app_name,
  students_active,
  completion_rate,
  iconColor,     // separate color for icon
  barColor,      // separate color for progress bar
  bgColor,
  icon,
}) => {
  let barBgColor = completion_rate >= '80%' ? '#16A34A' : completion_rate >= '60%' ? '#FFA21D' : '#EA580C'
  return (
    <div className="flex flex-col items-center justify-center p-6 bg-white rounded-2xl shadow-md w-full">
      {/* Icon */}
      <div className={`p-3 rounded-full ${bgColor} w-max mb-3`}>
        {/* <Icon className={`w-8 h-8 ${iconColor}`} /> */}
        <img src={icon || fallBackImage} alt={app_name} className="rounded-full w-12 h-12 object-cover"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = fallBackImage;
          }}
        />
      </div>

      {/* Title */}
      <h3 className="text-md font-semibold text-gray-800 text-center">{app_name}</h3>
      <p className="text-sm text-gray-500">{students_active} students active</p>

      {/* Progress Bar */}
      <div className="w-full mt-4">
        <div className="h-2 bg-gray-200 rounded-full">
          <div
            className={`h-2 rounded-full`}
            style={{ width: `${completion_rate}`, background: barBgColor }}
          ></div>
        </div>
        <p className="text-xs text-gray-500 mt-2 text-center">
          {completion_rate} completion rate
        </p>
      </div>
    </div>
  );
};

export default UsageCard;
